<template>
  <div id="totalBox">
    <div class="serviceLine">
      <div class="serviceBox">
        <p class="serviceEngTitle">Service</p>
        <p class="serviceTitle">智慧停车</p>
        <div class="serviceContent">
                 任马停是一款集成多技术于一体的服务平台。以移动互联网、物联网、云计算、大数据、人工智能以及超声雷达等技术为基础，针对停车难、停车乱、停车贵等一系列当今社会急需解决的问题所研发出的APP。
        </div>
        <img src="../../assets/home/serviceIcon.png" class="serviceIcon" />
      </div>
    </div>
    <div class="videoBox">
      <!--muted="true"-->
      <video :src=videoUrl class="videoPlayer" loop="loop" id="video" poster="../../assets/home/videoPage.png" controls="controls"></video>
    </div>
  </div>
</template>

<script>
//  import videoUrl from '../../assets/home/homeVideo.mp4'
export default {
  name: 'Service',
  data: function () {
    return {
      videoUrl: 'http://qiniu.renmating.com/homeVideo.mp4'
    }
  }
}
</script>

<style scoped>
#totalBox {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 935px;
}
.serviceLine{
  width: 100%;
  background-color: RGBA(248, 248, 248, 1);
  height: 728px;
}
.serviceBox {
  margin: 0 auto;
  width: 1200px;
  height: 100%;
  padding-top: 40px;
  position: relative;
}

.serviceEngTitle {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 182, 30, 1);
}

.serviceTitle {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(19, 19, 19, 1);
  margin-top: 20px;
}
.serviceContent{
  width: 914px;
  margin: 0 auto;
  margin-top: 30px;
  font-size:18px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(114,114,114,1);
  line-height:29px;
}
.serviceIcon{
  width:87px;
  height:114px;
  position: absolute;
  right: 0;
  top: 170px;
}
.videoBox{
  width: 100%;
  position: absolute;
  top: 254px;
}
.videoPlayer{
  outline: none!important;
  width: 1200px;
  height: 676px;
  box-shadow: 0 0 5px 5px rgba(224, 225, 224, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/home/service.vue